/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize PatientRecords View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientEventsView';

export const mapStateToPropsPatientEventsView = mapStateToProps;
export const mapDispatchToPropsPatientEventsView = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientEventsView,
  mapDispatchToPropsPatientEventsView
)(View);
